import React from "react";
import { JSONtoCSV } from "../../../util/data/JSONtoCSV";

const ManualEventPopup = ({ feature }: { feature: any }) => {
  const csvData = JSONtoCSV(feature.properties.items);
  const csvContent = "data:text/csv;charset=utf-8," + csvData;

  return (
    <div>
      {feature.properties.event_name} <br />
      {feature.properties.items.reduce(
        //@ts-ignore
        (p, c, i) => (p += parseInt(c.quantity)),
        0
      )}
      {" items cleaned up during this event"}
      <br />
      <a href={encodeURI(csvContent)} download={feature.properties.event_name}>
        Download data
      </a>
    </div>
  );
};

export default ManualEventPopup;
